import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import ReactLoading from "react-loading";
import { useMediaQuery } from "react-responsive";

import { useDispatch, useSelector } from "react-redux";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import {
  Button,
  MenuItem,
  Menu,
  Divider,
  Tabs,
  Tab,
  Dialog,
  Slide,
  TextField,
  DialogTitle,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import { Person } from "@material-ui/icons";
import { actions as authActions } from "../../../../app/modules/Auth/_redux/authRedux";
import { Formik } from "formik";
import Countdown from "react-countdown";
import {
  SignInWithMobile,
  VerifyLogin,
  loginWithMobile,
  login,
  VerifyRegister,
} from "../../../../app/modules/Homepage/pages/widgets/components/cruds";
import ReactCodeInput from "react-code-input";
import { LinearProgress } from "@material-ui/core";
import AuthModal from "../../../../app/modules/RUComponent/AuthModal";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function HeaderMobile() {
  let { state } = useSelector((state) => ({
    state: state.auth,
  }));

  const propsz = {
    className: "class-Input",
    inputStyle: {
      textAlign: "center",
      fontFamily: "sans",
      borderRadius: "6px",
      border: "1px solid lightgrey",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
      margin: "4px",
      paddingLeft: "8px",
      paddingRight: "0px",
      width: "10%",
      height: "42px",
      fontSize: "32px",
      boxSizing: "border-box",
      color: "black",
      backgroundColor: "white",
      direction: "ltr",
      flexGrow: 1,
    },
    touch: {
      border: "1px solid green",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "14px",
      height: "26px",
      paddingLeft: "7px",
      backgroundColor: "red",
      color: "red",
      border: "1px solid red",
    },
  };

  const [display, setDisplay] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("login");
  const [verifyTime, setVerifyTime] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);
  const [codeErrMessage, setCodeErrMessage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoginLoading, setIsLoginLoading] = React.useState(false);
  const [isPinLoading, setIsPinLoading] = React.useState(false);
  const [timeCounter, setTimeCounter] = React.useState(false);
  const [counterRemained, setCounterRemained] = React.useState(120000);

  const useStyles = makeStyles({
    barColorPrimary: {
      background: "red",
    },
  });

  const classes = useStyles();

  const counterRenderer = ({ total }) => {
    setCounterRemained(total);
    const mainMin = 120000;
    const onePercent = mainMin / 100;
    const leftedPercent = Math.floor(total / onePercent);

    return (
      <LinearProgress
        variant="determinate"
        value={leftedPercent}
        dir="ltr"
        style={{ height: "0.7rem", borderRadius: "10px" }}
        className={` w-75 mx-auto`}
      />
    );
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const dispatch = useDispatch();
  const history = useHistory();
  const uiService = useHtmlClassService();
  const splittedURL = history.location.pathname.split("/");

  const layoutProps = useMemo(() => {
    return {
      headerLogo: uiService.getStickyLogo(),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      headerMenuSelfDisplay:
        objectPath.get(uiService.config, "header.menu.self.display") === true,
      headerMobileCssClasses: uiService.getClasses("header_mobile", true),
      headerMobileAttributes: uiService.getAttributes("header_mobile"),
    };
  }, [uiService]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setVerifyTime(false);
    setOpen(false);
  };

  return (
    <>
      {/*begin::Header Mobile*/}
      <div
        id="kt_header_mobile"
        className={`header-mobile ${layoutProps.headerMobileCssClasses}`}
        {...layoutProps.headerMobileAttributes}
      >
        {/* begin::Logo */}
        <Link to="/">
          <img
            alt="Logo"
            className="logo-default max-h-30px"
            src={toAbsoluteUrl("/media/logos/logo-md.png")}
          />
        </Link>
        {/* end::Logo */}

        {/* begin::Toolbar */}
        <div className="d-flex align-items-center">
          {/* <div className="d-none d-md-block">
            <HeaderMenu />
          </div> */}
          <div className="d-block d-lg-none">
            {state.user?.user ? (
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <>
                    <Button
                      varient="outlined"
                      {...bindTrigger(popupState)}
                      className="d-flex align-items-center "
                      style={{
                        padding: "4px",
                        backgroundColor: "none",
                        border: "1px solid #6dd06d",
                        gap: "5px",
                      }}
                    >
                      <Person style={{ color: "#6dd06d", fontSize: "28px" }} />
                    </Button>
                    <Menu {...bindMenu(popupState)}>
                      <div className="d-flex flex-container container">
                        <span
                          className="text-dark opacity-90 font-weight-bolder font-size-base d-none d-md-inline mr-4 d-flex align-items-center"
                          style={{ gap: "4px" }}
                        >
                          <Person
                            style={{
                              color: "#6dd06d",
                              marginRight: "5px",
                              fontSize: "2.5rem",
                            }}
                          />
                          {state?.user?.user.firstName &&
                          state?.user?.user.lastName
                            ? `${state?.user?.user.firstName} ${state?.user?.user.lastName}`
                            : "کاربر"}
                        </span>
                      </div>
                      <Divider className="my-3 w-100" />
                      <Link to="/account/profile">
                        <MenuItem
                          onClick={popupState.close}
                          className="d-flex align-items-center"
                          style={{ gap: "15px" }}
                        >
                          <div>
                            <i
                              style={{ fontSize: "25px" }}
                              className="flaticon2-calendar-3 text-success"
                            ></i>
                          </div>
                          <div
                            className="d-flex flex-column"
                            style={{ gap: "3px" }}
                          >
                            <div
                              className="font-weight-bold text-dark"
                              style={{ fontSize: "12px", fontFamily: "sans" }}
                            >
                              حساب کاربری
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "14px", fontFamily: "sans" }}
                            >
                              مدیریت اطلاعات
                            </div>
                          </div>
                        </MenuItem>
                      </Link>
                      <Link to="/account/travels">
                        <MenuItem
                          onClick={popupState.close}
                          className="d-flex align-items-center"
                          style={{ gap: "15px" }}
                        >
                          <div>
                            <i
                              style={{ fontSize: "25px" }}
                              className="flaticon2-mail text-warning"
                            ></i>
                          </div>
                          <div
                            className="d-flex flex-column"
                            style={{ gap: "3px" }}
                          >
                            <div
                              className="font-weight-bold text-dark"
                              style={{ fontSize: "12px", fontFamily: "sans" }}
                            >
                              سفر ها
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "14px", fontFamily: "sans" }}
                            >
                              سفارش و استرداد
                            </div>
                          </div>
                        </MenuItem>
                      </Link>
                      <Link to="/account/transaction">
                        <MenuItem
                          onClick={popupState.close}
                          className="d-flex align-items-center"
                          style={{ gap: "15px" }}
                        >
                          <div>
                            <i
                              style={{ fontSize: "25px" }}
                              className="flaticon2-rocket-1 text-danger"
                            ></i>
                          </div>
                          <div
                            className="d-flex flex-column"
                            style={{ gap: "3px" }}
                          >
                            <div
                              className="font-weight-bold text-dark"
                              style={{ fontSize: "12px", fontFamily: "sans" }}
                            >
                              تراکنش های مالی
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "14px", fontFamily: "sans" }}
                            >
                              کلیه تراکنش ها
                            </div>
                          </div>
                        </MenuItem>
                      </Link>
                      <Link to="/account/recharge">
                        <MenuItem
                          onClick={popupState.close}
                          className="d-flex align-items-center"
                          style={{ gap: "15px" }}
                        >
                          <div>
                            <i
                              style={{ fontSize: "25px" }}
                              className="flaticon2-add text-primary"
                            ></i>
                          </div>
                          <div
                            className="d-flex flex-column"
                            style={{ gap: "3px" }}
                          >
                            <div
                              className="font-weight-bold text-dark"
                              style={{ fontSize: "12px", fontFamily: "sans" }}
                            >
                              افزایش شارژ
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "14px", fontFamily: "sans" }}
                            >
                              شارژ کیف پول
                            </div>
                          </div>
                        </MenuItem>
                      </Link>
                      <Divider className="w-100 mt-3" />
                      <div className="d-flex flex-wrap mt-4 mb-2">
                        <div className="col-12" style={{ height: "3rem" }}>
                          <Button
                            onClick={() => {
                              dispatch(authActions.logout());
                              history.push("");
                            }}
                            className="h-100 w-100 btn btn-light-primary font-weight-bold"
                          >
                            <h6 className="mx-auto my-auto">خروج</h6>
                          </Button>
                        </div>
                      </div>
                    </Menu>
                  </>
                )}
              </PopupState>
            ) : (
              <p
                style={{ fontSize: "16px", gap: "3px", marginLeft: "5px" }}
                className="mx-auto my-auto d-flex"
              >
                <span
                  onClick={() => {
                    setValue("register");
                    handleClickOpen();
                  }}
                  style={{ textDecorationLine: "underline" }}
                >
                  ثبت نام
                </span>
                <span style={{ color: "#6dd06d" }}>/</span>
                <span
                  onClick={() => {
                    setValue("login");
                    handleClickOpen();
                  }}
                  style={{ textDecorationLine: "underline" }}
                >
                  ورود
                </span>
              </p>
            )}
          </div>
          <AuthModal open={open} handleClose={handleClose} modal={value}/>
          {layoutProps.asideDisplay && (
            <button
              className="btn p-0 burger-icon burger-icon-left"
              id="kt_aside_mobile_toggle"
            >
              <span />
            </button>
          )}

          {layoutProps.headerMenuSelfDisplay && (
            <button
              className="btn p-0 burger-icon burger-icon-left ml-4"
              id="kt_header_mobile_toggle"
            >
              <span />
            </button>
          )}

          {/* <button
            className="btn btn-icon btn-hover-transparent-white p-0 ml-3"
            id="kt_header_mobile_topbar_toggle"
          >
            <span className="svg-icon svg-icon-xl">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </span>
          </button> */}
        </div>
        {/* end::Toolbar */}
      </div>
      {/* end::Header Mobile */} {/*end::Header Mobile*/}
    </>
  );
}
